import React, { useState, useEffect } from 'react';
import { AlertTriangle, LogOut, User, Building2, Eye } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { toast } from 'sonner';
import axios from 'axios';

const ImpersonationBanner = () => {
  const [impersonationData, setImpersonationData] = useState(null);

  useEffect(() => {
    checkImpersonation();
  }, []);

  const checkImpersonation = () => {
    const token = localStorage.getItem('access_token');
    const originalToken = localStorage.getItem('original_superadmin_token');
    
    if (token && originalToken) {
      // Decode token to get user info
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        
        setImpersonationData({
          isImpersonating: true,
          currentUser: {
            email: payload.email,
            role: payload.role,
            company_id: payload.company_id
          },
          impersonatedBy: payload.impersonated_by || 'superadmin'
        });
      } catch (error) {
        console.error('Failed to decode token:', error);
      }
    }
  };

  const handleExitImpersonation = async () => {
    try {
      const originalToken = localStorage.getItem('original_superadmin_token');
      
      if (!originalToken) {
        toast.error('Original token not found');
        return;
      }

      // Restore original superadmin token
      localStorage.setItem('access_token', originalToken);
      localStorage.removeItem('original_superadmin_token');
      
      toast.success('Exited impersonation mode');
      
      // Redirect to return path (companies or audit-firms)
      const returnTo = localStorage.getItem('impersonation_return_to') || '/companies';
      localStorage.removeItem('impersonation_return_to');
      setTimeout(() => {
        window.location.href = returnTo;
      }, 500);
    } catch (error) {
      console.error('Failed to exit impersonation:', error);
      toast.error('Failed to exit impersonation');
    }
  };

  if (!impersonationData?.isImpersonating) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg fixed top-0 left-0 right-0 z-[70] h-14">
      <div className="w-full h-full px-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 bg-white/20 rounded-full px-3 py-1">
              <Eye className="h-4 w-4" />
              <span className="text-sm font-semibold">IMPERSONATION MODE</span>
            </div>
            
            <div className="hidden sm:flex items-center gap-2 text-sm">
              <AlertTriangle className="h-4 w-4" />
              <span>You are viewing this session as:</span>
            </div>
            
          <div className="flex items-center gap-2">
            <Badge variant="secondary" className="bg-white/90 text-orange-700 hover:bg-white">
              <User className="h-3 w-3 mr-1" />
              {impersonationData.currentUser.email}
            </Badge>
            <Badge variant="secondary" className="bg-white/90 text-orange-700 hover:bg-white">
              <Building2 className="h-3 w-3 mr-1" />
              {impersonationData.currentUser.role}
            </Badge>
          </div>
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <div className="hidden md:block text-xs opacity-90">
            Support impersonation session
          </div>
          <Button
            variant="secondary"
            size="sm"
            onClick={handleExitImpersonation}
            className="bg-white text-red-600 hover:bg-white/90 font-semibold"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Exit Impersonation
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
